import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import PackerDeliveryOrderBatchRow from './packerDeliveryOrderBatchRow';
import DELIVERY_STATUS from '../../components/constants/deliveryStatus';

const PackerDeliveryRow = ({ delivery }) => {
  const isPacked =
    [DELIVERY_STATUS.readyForPickup.name, DELIVERY_STATUS.inProgress.name, DELIVERY_STATUS.finished.name].indexOf(
      delivery.status
    ) !== -1;

  return (
    <div className="packer__delivery m-t-6 m-b-6">
      <h3>
        {isPacked ? '✅ ' : ''}
        <FormattedMessage id={'packer.routes.route.view.delivery.title'} values={{ name: delivery.name }} />
      </h3>
      <div className="text-muted">
        <small>
          <FormattedMessage id={'packer.routes.route.view.delivery.id'} values={{ deliveryId: delivery.id }} />
        </small>
      </div>

      {delivery.deliveryOrderBatch ? <PackerDeliveryOrderBatchRow delivery={delivery} /> : ''}
    </div>
  );
};

PackerDeliveryRow.propTypes = {
  delivery: PropTypes.object.isRequired,
};

PackerDeliveryRow.defaultProps = {};

export default PackerDeliveryRow;
